import React, { useRef, useState } from 'react';
import {useTheme,InputAdornment,ButtonGroup, TextField,Select,FormControl,InputLabel, MenuItem,Box, Divider, Paper, Button, IconButton, Tooltip, Typography } from '@material-ui/core';

import AttachFileIcon from '@material-ui/icons/AttachFile';

import CloseIcon from '@material-ui/icons/Close';
import Close from '@material-ui/icons/Close';
import AttachFile from '@material-ui/icons/AttachFile';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import TheatersIcon from '@material-ui/icons/Theaters';
import SearchIcon from '@material-ui/icons/Search';
// import AssignmentIcon from '@material-ui/icons/Assignment';
import PostAddOutlinedIcon from '@material-ui/icons/PostAddOutlined';
import LinkIcon from '@material-ui/icons/Link';
// import SaveIcon from '@material-ui/icons/Save';
// import DeleteIcon from '@material-ui/icons/Delete';
// import { Scrollbars } from 'react-custom-scrollbars';
import FormInput from "../../../FormInput";
import { MuiThemeProvider } from "@material-ui/core/styles";
import useStyles,{ getMuiTheme } from "./styles";
import {clone } from "ramda";
import { toast } from "react-toastify";
import SpeedDials from "./SpeedDials";
// import {pathOr} from "ramda";

import CircularProgress from '@material-ui/core/CircularProgress';
import { useLayoutState} from '../../../../context/LayoutContext';

const EmailForm = ({initialValues,setInitialValues,onChange,metaData,modalState,handleClose,emailSubmitLoader,attachedFiles, setAttachedFiles,attachedDocuments, setAttachedDocuments,handleSubmit})=> {
 // console.log("EmailForm metaData",metaData);
  const classes = useStyles();
  const theme = useTheme();
  const fileInputRef = useRef(null);
  const { isSidebarOpened } = useLayoutState();
  
  const [openCC, setOpenCC] = useState(false);
  const [openBCC, setOpenBCC] = useState(false);

  const [openRelateTo, setOpenRelateTo] = useState(false);
  const [openRelateCC, setOpenRelateCC] = useState(false);
  const [openRelateBCC, setOpenRelateBCC] = useState(false);

  const [openRelatedTo, setOpenRelatedTo] = useState(initialValues && initialValues.parent_type);
  const [fullscreen, setFullscreen] = useState(false);
  const [error, setError] = useState(null);
  
   
  const handleChange = (field,val) => {
   onChange(field,val)
  };

  const handleAttach = () => {
    fileInputRef.current.click();
  };

const validateAndChange = files => {
  setError(null);
    let prevFiles = clone(attachedFiles);
    //console.log("files",files);
    Object.entries(files).map((file,key)=>{
      
      prevFiles.push(file[1]);
      
      if (file[1].type.includes("image")) {
        if (file[1].size / 1000 <= 500) {
          //onChange(file);
          return;
        } else {
          setError("Choose image within 500kb");
          return;
        }
      }
      if(file[1] &&  (file[1].size / 1000) <= 2000){
        //onChange(file);
      } else {
        setError("Choose document within 2mb");
      }

    });
    toast("Files attached!");
    setAttachedFiles(prevFiles);
    const timeout = setTimeout(() => {
      const timeline1 = document.getElementById('attachmentContainer');  

      timeline1.scrollIntoView({ behavior: "smooth", block: 'center' });  
    }, 1000);
    
  }
   const deleteAttachment = (type,key)=>{
    let data = clone((type==='file')?attachedFiles:attachedDocuments);
    data.splice(key,1);
    if(type==='file')
    setAttachedFiles(data);
    if(type==='document')
    setAttachedDocuments(data);
  }
  const addDocument = (files)=>{
    let prevFiles = clone(attachedDocuments);
    prevFiles.push(files);
    setAttachedDocuments(prevFiles);
    toast("Documents attached!");
    const timeout = setTimeout(() => {
      const timeline1 = document.getElementById('attachmentContainer');  

      timeline1.scrollIntoView({ behavior: "smooth", block: 'center' });  
    }, 1000);
  }
  const renderFromOptions = () => {
    let optionsToRender = [];
    for (let optionKey in metaData[0].attributes[1][0].options) {
      optionsToRender.push(
        <MenuItem key={optionKey} value={optionKey}>
          <span>{metaData[0].attributes[1][0].options[optionKey]}</span>
        </MenuItem>
      );
    }
    return optionsToRender;
  };
  const setEmails =(type, val)=>{
    setOpenRelateTo(false);
    setOpenRelateCC(false);
    setOpenRelateBCC(false);
    setInitialValues({...initialValues,[type]:(initialValues[type])?initialValues[type]+", "+val.email:val.email});
  }
  const onSubmit = (e)=>{
    e.preventDefault();
    handleSubmit(initialValues);
  }
  const handleSaveDraft = ()=>{
    let data = clone(initialValues);
    data.send="0";
   // console.log(data);
    handleSubmit(data);
   // handleClose();
  }

  function truncate(str,n) {
    return str?.length > n ? str.substr(0,n-1) + "..." : str;
  }

  return (
    <>
    {(modalState)?
      (
      <MuiThemeProvider theme={getMuiTheme(theme)}>
      <Paper
        className={classes.composeBox}
        elevation={1}
        //style={{width: (!fullscreen)?`50vw`:`${isSidebarOpened?80:90}vw`,minHeight: (!fullscreen)?"70vh":"90vh",}}
        style={{width: (!fullscreen)?`50vw`:`${isSidebarOpened?80:90}vw`}}
    
      >
        <form onSubmit={onSubmit} noValidate autoComplete="off">
        <Box  className={classes.composeHeader}>
          <Typography variant="subtitle1" gutterBottom>{metaData[0].label}</Typography>
          <Box style={{flexGrow: 1}}></Box>
          <Button className={classes.fullscreenBtn} onClick={()=>setFullscreen(!fullscreen)}>
            {!fullscreen?<FullscreenIcon />:<FullscreenExitIcon />}
          </Button>
          <Button className={classes.closePopupBtn} onClick={()=>handleClose()}><CloseIcon /></Button>        
        </Box>
        <Box  className={classes.composeBody}>
          
       <Box>   
        <FormControl style={{display:"flex" , width:"100%", margin:"0 5px"}} >
          <InputLabel>From</InputLabel>
          <Select          
          onChange={(e)=>handleChange("from_addr_name",e.target.value)}
          fullWidth
          style={{textAlign:"left"}}
          className={classes.inputField}
          name="from_addr_name"
          value={initialValues.inbound_email_id?initialValues.inbound_email_id:''}
          //value={pathOr(initialValues.inbound_email_id?initialValues.inbound_email_id:'',[0],Object.keys(pathOr([{[initialValues.inbound_email_id?initialValues.inbound_email_id:'']:""}],[0,"attributes",1,0,"options"],metaData)))}
          >
          {renderFromOptions()}
          
        </Select>
      </FormControl>
      
      <TextField label="To" className={classes.textArea}  onChange={(e)=>handleChange("to_addrs_names",e.target.value)}
      name="to_addrs_names" 
      value={initialValues.to_addrs_names?initialValues.to_addrs_names:''}
         InputProps={{
            endAdornment: <InputAdornment position="start">
                  {
                    openRelateTo?<SpeedDials hidden={openRelateTo} handleClose={()=>setOpenRelateTo(false)} type="to" setEmails={(val)=>setEmails("to_addrs_names",val)} />:""
                  }
                  
                  <Tooltip title="Select from CRM">
                  <Button onClick={()=>setOpenRelateTo(!openRelateTo)} className={classes.inputAdornmentBtn}><SearchIcon /></Button>
                  </Tooltip>
                  <Tooltip title="Add CC">
                  <Button onClick={()=>setOpenCC(!openCC)} className={classes.inputAdornmentBtn}>CC</Button>
                  </Tooltip>
                  <Tooltip title="Add BCC">
                  <Button onClick={()=>setOpenBCC(!openBCC)} className={classes.inputAdornmentBtn}>BCC</Button>
                  </Tooltip>
                </InputAdornment>,
          }}
        />
        {openCC?(<TextField id="cc" label="CC" className={classes.textArea}  onChange={(e)=>handleChange("cc_addrs_names",e.target.value)} name="cc_addrs_names" 
        value={initialValues.cc_addrs_names?initialValues.cc_addrs_names:''}
        InputProps={{
            endAdornment: <InputAdornment position="start">
                  {
                    openRelateCC?<SpeedDials hidden={openRelateCC} type="cc" setEmails={(val)=>setEmails('cc_addrs_names',val)} />:""
                  }
                  <Tooltip title="Select from CRM">
                  <Button onClick={()=>setOpenRelateCC(!openRelateCC)} className={classes.inputAdornmentBtn}><SearchIcon /></Button>
                  </Tooltip>
                  </InputAdornment>
            }}
        />):""
        
        }
        {openBCC?(<TextField id="bcc" label="BCC" className={classes.textArea}  onChange={(e)=>handleChange("bcc_addrs_names",e.target.value)} name="bcc_addrs_names" 
        value={initialValues.bcc_addrs_names?initialValues.bcc_addrs_names:''}
        InputProps={{
            endAdornment: <InputAdornment position="start">
                  {
                    openRelateBCC?<SpeedDials hidden={openRelateBCC} type="bcc" setEmails={(val)=>setEmails('bcc_addrs_names',val)} />:""
                  }
                  <Tooltip title="Select from CRM">
                  <Button onClick={()=>setOpenRelateBCC(!openRelateBCC)} className={classes.inputAdornmentBtn}><SearchIcon /></Button>
                  </Tooltip>
                  </InputAdornment>
            }}
        />):""}
        
        
       
        <TextField 
          style={{marginTop:10}} 
          label="Subject" 
          className={classes.textArea} 
          onChange={(e)=>handleChange("name",e.target.value)}          
          value={initialValues.name?initialValues.name:''}
          InputProps={{
            endAdornment: <InputAdornment position="start">
                    <Tooltip title="Related To">
                      <IconButton onClick={()=>setOpenRelatedTo(!openRelatedTo)}>
                        <PostAddOutlinedIcon />
                        </IconButton>
                        </Tooltip>
                    </InputAdornment>,
            }}
        />
        {(openRelatedTo || (initialValues && initialValues.parent_type))?(
          <div style={{margin:8}}>
          <FormInput
            variant="outlined"
            
            field={metaData[0].attributes[0][1]}
            // initialValues={initialValues}
            value={initialValues.parent?initialValues.parent:null}
            onChange={(val) => {handleChange("parent_name",val)}}
            /></div>
        ):""}
        </Box>
        
          <Divider light />
          <FormInput
            //height={fullscreen?"40vh":"20vh"}
            field={{type:"wysiwyg",name:"description",value:""}}
            // initialValues={initialValues}
            value={initialValues.description?initialValues.description:''}
            onChange={(val) => {handleChange("description",val)}}
            toolbar={{options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'history'],inline: { inDropdown: true },list: { inDropdown: true },textAlign: { inDropdown: true },link: { inDropdown: true },}}
            toolbarCustomButtons={[]}
            module={"Emails"}
          />
        <Divider light />
        <Box className={classes.composeAttachments} id="attachmentContainer">
          {
          (attachedFiles && attachedFiles.length>0)?
            (<>
            {
              attachedFiles.map((file,key)=>(
                <Tooltip title={file.name}>
                <ButtonGroup className={classes.attachments} variant="contained" color="primary"> 
                  <Button size="small" color="primary" variant="outlined" className={classes.attachmentBtn}><AttachFile />{truncate(file.name,15)}</Button>
                    <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      className={classes.attachmentIconBtn}
                      onClick={()=>deleteAttachment('file',key)}
                    >
                      <Close />
                    </Button>
                </ButtonGroup>
                </Tooltip>
              ) 
              )
            }</>):""
          }
          {
          (attachedDocuments && attachedDocuments.length>0)?
            (<>
            {
              attachedDocuments.map((file,key)=>(
                <Tooltip title={file.value}>
                <ButtonGroup className={classes.attachments} variant="contained" color="primary">
                  <Button size="small" color="primary" variant="outlined" className={classes.attachmentBtn}><LinkIcon />{truncate(file.value,15)}</Button>
                    <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      className={classes.attachmentIconBtn}
                      onClick={()=>deleteAttachment('document',key)}
                    >
                      <Close />
                    </Button>
                </ButtonGroup>
                </Tooltip>
              ) 
              )
            }</>):""
        }
        </Box>
        
        </Box>
        <Divider light />
        <Box className={classes.composeFooter}>
          {emailSubmitLoader ? <CircularProgress /> :
          <Button
            className={classes.sendButton}
            color="primary"
            variant="contained"
            type="submit"
            disabled={!initialValues.from_addr_name && !initialValues.to_addrs_names && !initialValues.description }
          >
            Send
          </Button> }
          <Tooltip title="Attach Files">
            <IconButton onClick={handleAttach}>
              <AttachFileIcon />
                <input
                  type="file"
                  accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*"
                  style={{ display: "none" }}
                  multiple={true}
                  onChange={(e) => validateAndChange(e.target.files)}
                  onClick={(event)=> { event.target.value = null}}
                  className={classes.fileInput}
                  ref={fileInputRef}
                />
            </IconButton>
          </Tooltip>
          
          <FormInput
            field={{type:"relate"}}
            // initialValues={initialValues}
            value=""
            isIconBtn={true}
            btnIcon = {<LinkIcon />}            
            module="Documents"
            view="ComposeEmail"
            tooltipTitle="Attach Documents"
            onChange={(val) => {addDocument(val)}}
          />

           <FormInput
            field={metaData[0].attributes[0][0]}
            // initialValues={initialValues}
            value={initialValues.description?initialValues.description:''}
            module="EmailTemplates"
            isIconBtn={true}
            btnIcon = {<TheatersIcon />}  
            onChange={(val) => {handleChange("emails_email_templates_name",val)}}
            tooltipTitle="Choose Email Template"
          />

          {/* <Tooltip title="Save Draft">
            <IconButton onClick={()=>handleSaveDraft()}>
              <SaveIcon />
            </IconButton>
          </Tooltip> */}
            {/*
          <Tooltip title="Disregard Draft">
            <IconButton>
              <DeleteIcon />
            </IconButton>
          </Tooltip> */}
         
          
          </Box>
        
        </form>
      </Paper></MuiThemeProvider>):""}</>
      
  );
};

// EmailForm.propTypes = {
//   className: PropTypes.string
// };

export default EmailForm;
